export default "__VITE_ASSET__CEvPtYvE__"